var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout-container"},[_c('a',{staticClass:"logout-link",on:{"click":_vm.logout}},[_c('Icon',{attrs:{"type":"md-log-out"}}),_c('span',[_vm._v(_vm._s(_vm.$t('logout')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }